import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Upload = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M13 24H19C19.55 24 20 24.45 20 25V29C20 29.55 19.55 30 19 30H13C12.45 30 12 29.55 12 29V25C12 24.45 12.45 24 13 24ZM18 26H14V28H18V26Z" />
		<path d="M16 2C17.05 2 18.087 2.425 18.825 3.175L24.825 9.175C25.575 9.925 26 10.95 26 12C26 14.2 24.2 16 22 16C21.3 16 20.6 15.812 20 15.463V21C20 21.55 19.55 22 19 22H13C12.45 22 12 21.55 12 21V15.588C11.4 15.938 10.7 16.125 10 16.125C7.8 16.125 6 14.325 6 12.125C6 11.075 6.425 10.037 7.175 9.3L13.162 3.188C13.912 2.425 14.949 2 16 2V2ZM22 14C23.1 14 24 13.1 24 12C24 11.475 23.788 10.963 23.413 10.588L17.413 4.588C17.038 4.213 16.526 4 16 4C15.474 4 14.963 4.213 14.588 4.588L8.588 10.7C8.213 11.075 8 11.6 8 12.125C8 13.225 8.9 14.125 10 14.125C10.525 14.125 11.037 13.912 11.412 13.537L12.287 12.662C12.574 12.375 13 12.287 13.375 12.449C13.75 12.599 13.988 12.974 13.988 13.374V19.999H17.988V13.237C17.988 12.837 18.226 12.462 18.601 12.312C18.976 12.162 19.401 12.237 19.688 12.525L20.563 13.4C20.963 13.787 21.476 14 22.001 14H22Z" />
	</svg>
);

export default Upload;
